import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import * as _ from 'lodash'

@Injectable({
  providedIn: 'root'
})
export class BodegaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  GetBodegas(rutEmpresa: number, sucursalCodigo: number, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query(
            $rut_empresa: Decimal,
            $sucursal_codigo: Decimal
          )
          {
          bodega {
            obtenerSegunFiltro (
              filtro: {
                exacto: {
                  rut_empresa: $rut_empresa,
                  sucursal_codigo: $sucursal_codigo,
                  tipobusqueda: 1
                }
              })
              {
                respuesta{
                  registros{
                    nombre
                    codigo
                    descripcion
                    sucursal_codigo
                    principal
                  }
                }
            }
          }
        }
        `,
        variables: {
          rut_empresa: rutEmpresa,
          sucursal_codigo: sucursalCodigo
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        let { mensajes, respuesta } = _.cloneDeep(response.data.bodega.obtenerSegunFiltro)
        let { registros } = respuesta
        if (respuesta && respuesta.registros) {
          registros = _.orderBy(registros, ['principal', 'nombre'], ['desc', 'asc'])
          registros.map(bodega => {
            if (bodega.principal) {
              bodega.nombre = `${bodega.nombre} (PRINCIPAL)`
            }
          })
        }
        callback({ mensajes, respuesta })
      }
    );
  }

  ObtenerBodegas(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($rut_empresa: Decimal, $sucursal_codigo: Decimal) {
          bodega {
            obtenerSegunFiltro(filtro: {exacto: {rut_empresa: $rut_empresa, sucursal_codigo: $sucursal_codigo, tipobusqueda: 1}}) {
              respuesta {
                registros {
                  nombre
                  codigo
                  descripcion
                  sucursal_codigo
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.bodega.obtenerSegunFiltro
        callback({ mensajes, respuesta })
      }
    );
  }
}
